import React from 'react'
import ArticleContentEditor from '../../../components/forms/Editor/ArticleContentEditor'
import Form from '../../../components/forms/utils/Form'
import { useOutletContext } from 'react-router-dom'
import { useMutation } from '@apollo/client'
import { UPDATE_PUBLICATION_QUERY } from '../../../utils/api-utils'
import { CampaignContentSource, CampaignType, PublicationStatus } from '../../../__generated__/graphql'
import SelfHostedArticle from '../SelfHostedArticle'
import ProviderContent from '../ProviderContent'

const Content = () => {
  const {publication, campaign} = useOutletContext<any>()
  const {__typename, ...defaultValues} = publication.content || {}
  const readOnly = ![PublicationStatus.Draft, PublicationStatus.Paused].includes(publication.status)

  const [updatePublication, { loading }] = useMutation(
    UPDATE_PUBLICATION_QUERY
  );

  if (campaign.contentSource === CampaignContentSource.ProviderContent) {
    return <ProviderContent publications={[publication]} publicationMode />
  }

  const handleUpdateArticle = async (allValues: any) => {
    updatePublication({
      variables: { id: publication._id, record: {content: allValues}}
    })
  }

  if (publication.website.allowSelfHostedAdvertorials) {
    return <SelfHostedArticle publication={publication} />
  }

  return (
    <Form
      className='flex-1 relative bg-white rounded-md px-4 py-4 mb-10 space-y-6 sm:space-y-5'
      defaultValues={defaultValues}
      submitButtonText='Customize Article'
      onSubmit={handleUpdateArticle}
      loading={loading}
      readOnly={readOnly}
    >
        <ArticleContentEditor readOnly={readOnly} allowSponsoredLinks={campaign.type === CampaignType.Filler} />
    </Form>
  );
};

export default Content;
